import React from "react";
import { Link } from "react-router-dom";
import { Swords, Zap, GitBranch, ShieldCheck, FileDown, Bot, ArrowUpRight } from "lucide-react";
import { TID } from "@/lib/testIds";

const MODULES = [
    { id: "forge", icon: Swords, to: "/roles", title: "Sentinel Forge", desc: "Engineer & verify PFCG roles" },
    { id: "instant", icon: Zap, to: "/instant-analysis", title: "Instant Analysis", desc: "T-code & Fiori lookup, zero setup" },
    { id: "diagrams", icon: GitBranch, to: "/roles", title: "Diagram Studio", desc: "SAP diagrams as vector SVG" },
    { id: "governance", icon: ShieldCheck, to: "/governance", title: "Governance", desc: "SoD rules, controls, frameworks" },
    { id: "reports", icon: FileDown, to: "/reports", title: "Deliverables", desc: "PDF · DOCX · XLSX · PPTX" },
    { id: "utsav", icon: Bot, to: "/utsav", title: "Utsav Agent", desc: "Ask, simulate, draft — by voice" },
];

/** Outlined module tiles: the launchpad row from the design, with a visible
 * label AND description on every tile so nothing depends on icon literacy. */
export function ModuleLaunchpad() {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid={TID.moduleLaunchpad}>
            {MODULES.map((m) => (
                <Link
                    key={m.id}
                    to={m.to}
                    data-testid={TID.moduleTile(m.id)}
                    className="group panel p-4 hover:border-cyan-500/45 transition-colors relative overflow-hidden"
                >
                    <ArrowUpRight size={12} className="absolute top-3 right-3 text-slate-600 group-hover:text-cyan-300 transition-colors" />
                    <span className="w-9 h-9 rounded-sm border border-cyan-500/30 bg-cyan-500/5 flex items-center justify-center">
                        <m.icon size={16} className="text-cyan-300" strokeWidth={1.5} />
                    </span>
                    <div className="font-display text-sm text-white mt-3">{m.title}</div>
                    <div className="text-[11px] text-slate-400 leading-snug mt-1">{m.desc}</div>
                </Link>
            ))}
        </div>
    );
}
